export default "__VITE_ASSET__c6fb9f0b__"